import * as TK from 'components/common/ArrangementsGrid/translations/constants';

export const arrangementsGridCommonLocale = {
  [TK.SHOW_MORE]: 'View all',
};
